import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

interface Props {
  status: any;
  isOwner: boolean;
  continueAction?: () => void;
  viewSummaryAction?: () => void;
  modifyAction?: () => void;
  cancelAction?: () => void;
  deleteAction?: () => void;
  minorChangesAction?: () => void;
}

const ActionsMenu: React.FC<Props> = ({
  status,
  isOwner,
  continueAction,
  viewSummaryAction,
  modifyAction,
  cancelAction,
  deleteAction,
  minorChangesAction
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const isInProgress = status === "InProgress";
  const isPublished = status === "Published";

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return isInProgress || isPublished ? (
    <div>
      <IconButton
        aria-label="more"
        id="actions-button"
        aria-controls={open ? "actions-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="actions-menu"
        MenuListProps={{
          "aria-labelledby": "actions-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {continueAction && isInProgress && isOwner && (
          <MenuItem
            onClick={() => {
              handleClose();
              continueAction();
            }}
          >
            {t("continue")}
          </MenuItem>
        )}
        {viewSummaryAction && isInProgress && !isOwner && (
          <MenuItem
            onClick={() => {
              handleClose();
              viewSummaryAction();
            }}
          >
            {t("viewSummary")}
          </MenuItem>
        )}
        {cancelAction && isInProgress && isOwner && (
          <MenuItem
            onClick={() => {
              handleClose();
              cancelAction();
            }}
          >
            {t("cancel")}
          </MenuItem>
        )}
        {modifyAction && isPublished && (
          <MenuItem
            onClick={() => {
              handleClose();
              modifyAction();
            }}
          >
            {t("modify")}
          </MenuItem>
        )}
        {deleteAction && isPublished && (
          <MenuItem
            onClick={() => {
              handleClose();
              deleteAction();
            }}
          >
            {t("delete")}
          </MenuItem>
        )}
        {minorChangesAction && isPublished && (
          <MenuItem
            onClick={() => {
              handleClose();
              minorChangesAction();
            }}
          >
            {t("republishMinorChange")}
          </MenuItem>
        )}
      </Menu>
    </div>
  ) : (
    <></>
  );
};

export default ActionsMenu;
